"use strict";
/**
 * Define socket.io interface
 *
 * Fill out eventParams and eventReturns_ with the client and server events, respectively
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketWrapper = exports.eventReturns = exports.eventReturns_ = void 0;
const Chat_1 = __importDefault(require("./api/Chat"));
const APIError_1 = __importDefault(require("./APIError"));
const zod_1 = __importDefault(require("zod"));
const eventParams = {
    "chat:message": zod_1.default.tuple([Chat_1.default.sendMessageParamsSchema]),
    "chat:message-voice": zod_1.default.tuple([zod_1.default.instanceof(File), Chat_1.default.sendVoiceMessageParamsSchema]),
};
exports.eventReturns_ = {
    "chat:message": zod_1.default.tuple([Chat_1.default.sendMessageReturnSchema]),
};
const eventErrorReturns = Object.fromEntries(Object.keys(eventParams).map((k) => [`${k}:error`, zod_1.default.tuple([APIError_1.default.responseSchema])]));
exports.eventReturns = Object.assign(Object.assign({}, exports.eventReturns_), eventErrorReturns);
class SocketWrapper {
    constructor(socket) {
        this.listenerMap = new Map();
        this.socket = socket;
    }
    get wrappedSocket() {
        return this.socket;
    }
    disconnect() {
        this.socket.disconnect();
        return this;
    }
    /**
     * Emit an event to the server with validation
     * @param event Event name
     * @param params Data to emit
     */
    emit(event, ...params) {
        var _a;
        console.log(event, params);
        const schema = (_a = eventParams[event]) !== null && _a !== void 0 ? _a : zod_1.default.any();
        const data = schema.parse(params);
        console.log(">", event, data);
        this.socket.emit(event, ...data);
        return this;
    }
    /**
     * Remove a specific event listener
     * @param event Event name
     * @param listener Event handler to remove
     */
    off(event, listener) {
        const hooks = this.listenerMap.get(event);
        if (!hooks)
            return this;
        const hook = hooks.get(listener);
        if (hook) {
            this.socket.off(event, hook); // socket.io typescript annotations are horrific
            hooks.delete(listener);
        }
        if (hooks.size === 0)
            this.listenerMap.delete(event);
        return this;
    }
    /**
     * Register an event listener with preprocessing (e.g., parsing dates)
     * @param event Event name
     * @param listener Event handler
     */
    on(event, listener) {
        var _a, _b;
        const schema = (_a = exports.eventReturns[event]) !== null && _a !== void 0 ? _a : zod_1.default.any();
        const hook = (...params) => listener(...schema.parse(params));
        if (!this.listenerMap.has(event))
            this.listenerMap.set(event, new Map());
        (_b = this.listenerMap.get(event)) === null || _b === void 0 ? void 0 : _b.set(listener, hook);
        this.socket.on(event, hook); // socket.io typescript annotations are horrific
        return this;
    }
}
exports.SocketWrapper = SocketWrapper;
